<template>
  <div class="relative flex w-full flex-1 min-h-0">
    <section
      class="home-landing-hero hero-section relative flex w-full flex-col justify-center"
      aria-label="Landing hero"
    >
      <div
        class="hero-section__content mx-auto flex w-full max-w-screen-2xl stack-6 justify-center px-4 text-center md:gap-0 flex-wrap py-16 md:py-20 md:px-0 mikeT"
      >
        <div class="w-full max-w-[200px] shrink-0 lg:max-w-[461px] 2xl:max-w-[561px]">
          <img
            class="h-auto w-full object-contain"
            src="@/assets/images/home-logo.png"
            alt="logo SIGCOM"
          />
        </div>

        <div class="flex flex-col items-center text-main">
          <h1 class="text-6xl font-extrabold leading-none lg:text-8xl xl:text-[128px]">SIGCOM</h1>

          <h3
            class="mb-4 mt-2 w-full max-w-[750px] text-xl font-medium uppercase leading-snug sm:mb-6 lg:text-3xl xl:text-4xl"
          >
            {{ $t('home.main.desc') }}
          </h3>

          <span class="text-lg font-medium text-black lg:text-2xl">
            {{ $t('home.main.action') }}
          </span>

          <!--
            Un seul accès : le géoportail communal se rejoint par le sélecteur de commune de
            l'en-tête, valable pour toutes les communes et non pour la seule Soa.
          -->
          <div class="mt-6 flex w-full justify-center">
            <button
              type="button"
              class="home-landing-hero__btn-central h-11 min-w-[10.25rem] cursor-pointer rounded-xl px-6 text-sm font-semibold text-white transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--color-main)] focus:ring-offset-2 md:text-base"
              @click="goToGeoportailCentral"
            >
              {{ $t('home.geoportailCentral') }}
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { RoutesKey } from '@/models/enums/app/RoutesKey'
import { useRouter } from 'vue-router'

const router = useRouter()

function goToGeoportailCentral(): void {
  router.push({ name: RoutesKey.GEOPORTAIL })
}
</script>

<style scoped>
.hero-section {
  position: relative;
  padding: 1.5rem;

  &::before {
    content: '';
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
    /* top: 1.5rem;
    left: 1.5rem;
    right: 1.5rem;
    bottom: 1.5rem; */
    box-sizing: border-box;
    z-index: 0;
    background: url('@/assets/images/bg-background.png') bottom center/cover no-repeat;
    /* border-radius: 1rem; */
  }
}

.hero-section__content {
  position: relative;
  z-index: 1;
  padding-top: 5.5rem;
}

/* Central geoportal: teal */
.home-landing-hero__btn-central {
  background-color: var(--color-main);
}

.home-landing-hero__btn-central:hover {
  background-color: var(--color-main-hover);
}

.mikeT {
  padding-top: 0;
}
</style>
